export const HERO_VIDEO_FILE = "all-the-food-is-poison-4x3.61eba37a7c9a.v2.mp4";
export const HERO_POSTER_FILE = "all-the-food-is-poison-4x3.c8df621b3ccd.v2.jpg";

export const HERO_VIDEO_PATH = `/media/${HERO_VIDEO_FILE}`;
export const HERO_POSTER_PATH = `/media/${HERO_POSTER_FILE}`;

export function mediaObjectKey(asset: string): string | null {
  if (asset === HERO_VIDEO_FILE || asset === HERO_POSTER_FILE) return `video/${asset}`;
  return null;
}
